import { useI18n } from '@i18n/useI18n';
import {useStore} from '@store/appStore';
import {SortContainer, SortWrapper} from './SortOptions.styled';
import ArrowDown from '@assets/svg/chevron-down.svg';
import {useEffect, useState} from 'react';
import {useDetectClickOutside} from "react-detect-click-outside";

const sortTypes = [
    "A-Z",
    "Z-A",
    "%",
  ]

const courseSortTypes = [
    "course A-Z",
    "course Z-A",
    "% desc",
    "% asc"
]

interface IProps {
    content?:any,
    setSort?:(any) => any,
    course?:boolean,
    counselor?:boolean
}

export const SortOptions = (props: IProps) => {
  const { settings } = useStore();
  const i18n = useI18n();
  const [sortType, setSortType] = useState<string>(props.course?courseSortTypes[0]:sortTypes[0]);
  const [open, setOpen] = useState(false);
    const ClickOutside = () => {
        setOpen(false)
    }
    const ref = useDetectClickOutside({ onTriggered: ClickOutside });

  useEffect(() => {
    if(sortType === sortTypes[0]){

    } else if (sortType === sortTypes[2]){
      
    }
  }, [sortType])

  const NormalSort = () => {

  }

  const PercentageSort = () => {
    
  }

  const updateSort = (s) => {
      setSortType(s)
      props.setSort(s)
      setOpen(false)
  }

  return (
    <SortWrapper ref={ref} open={open} onClick={() => setOpen(!open)} course={props.course} counselor={props.counselor}>
      {i18n.t(sortType)}
      <ArrowDown />
      <SortContainer open={open}>
        {props.course?courseSortTypes.map((s, index) => {
            return <span onClick={() => updateSort(s)} key={s + "_" + index}>{i18n.t(s)}</span>
        }):sortTypes.map((s, index) => {
            return <span onClick={() => updateSort(s)} key={s + "_" + index}>{i18n.t(s)}</span>
        })}
      </SortContainer>
    </SortWrapper>
  );
};

export default SortOptions;
